import React, { PureComponent, memo } from 'react';
import styled from 'styled-components/macro';
import { isString, get } from 'lodash';
import { Focusable } from './navigation';
import scaleSize from '../utils/scale-size';
import config from '../config';
import { LIST_ITEMS_BACKGROUND_BY_TYPE, LIST_ITEMS_SIZE, LIST_TYPES } from 'config';
import getImagePath from '../utils/get-image-path';
import getLocalized from '../utils/get-localized';
import runtimeToSeconds from '../utils/runtime-to-seconds';
import PlayIcon from './Icons/item-play';
import CrossIcon from './Icons/cross';
import Progress from './Progress';
import i18n from '../i18n';
import moment from 'moment';
import { INIT_UI_LANGUAGE } from 'constants/languages';

// TODO: полный рефактор
// Для каждого типа listItem должен быть простой и расширяемый view компонент

export const LIST_ITEM_MARGIN = 19;

const StyledPlayIcon = styled(PlayIcon)`
  position: absolute;
  bottom: ${scaleSize(20)}px;
  right: ${scaleSize(20)}px;
`;

const ListItemTitle = styled.span`
  display: block;
  word-break: break-word;
  white-space: normal;
  font-family: RobotoCondensedBold, sans-serif;
  font-size: ${({ contentSize, showProgress }) =>
    contentSize === LIST_TYPES.SMALL_BANNER
      ? `${scaleSize(28)}px`
      : showProgress
      ? `${scaleSize(30)}px`
      : `${scaleSize(33)}px`};
  font-weight: bold;
  text-align: ${({ contentSize }) => (contentSize === LIST_TYPES.SMALL_BANNER ? `center` : `left`)};
  letter-spacing: ${scaleSize(-0.24)}px;
  line-height: ${({ contentSize }) =>
    contentSize === LIST_TYPES.SMALL_BANNER ? `${scaleSize(64)}px` : `${scaleSize(44)}px`};
  width: ${({ itemSize }) => scaleSize(itemSize.width - 16)}px;
  min-height: ${scaleSize(45)}px;
  max-height: ${scaleSize(90)}px;
  margin-bottom: ${scaleSize(5)}px;
  color: ${({ contentSize, theme }) =>
    contentSize === LIST_TYPES.SMALL_BANNER ? theme.defaultColor : theme.mainTextColor};
  transform: translate3d(0, 0, 0);
  transition: ${config.withAnimation ? 'transform 0.2s' : 'none'};
  //display: block;
  opacity: ${({ hideTitle }) => +!hideTitle};
  //white-space: normal;
  padding: 0 ${scaleSize(10)}px;
  margin-top: ${({ contentSize }) =>
    contentSize === LIST_TYPES.SMALL_BANNER ? `${scaleSize(-100)}px` : `${scaleSize(10)}px`};
  //Check on TV;
  overflow: hidden;
`;

const ListItemFiltersTitle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
  text-align: center;
  padding: ${scaleSize(10)}px;
  box-sizing: border-box;
  font-family: RobotoMedium, sans-serif;
  font-size: ${scaleSize(42)}px;
  font-weight: bold;
  text-shadow: 1px 1px 6px rgba(0, 0, 0, 1);
  width: 100%;
  height: ${({ itemSize }) => scaleSize(itemSize.height)}px;
  color: ${({ theme }) => theme.defaultColor};
  transform: translate3d(0, 0, 0);

  & > span {
    line-height: 1.15;
  }
`;

const ListItemMetadata = styled.i`
  font-family: RobotoMedium, sans-serif;
  font-size: ${scaleSize(28)}px;
  line-height: 1.17;
  height: ${scaleSize(34)}px;
  width: auto;
  font-weight: 500;
  letter-spacing: ${scaleSize(-0.17)}px;
  color: ${({ theme }) => theme.secondaryTextColor};
  font-style: normal;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  opacity: ${({ hideTitle }) => +!hideTitle};
  text-align: left;
  padding: ${({ showProgress }) => (showProgress ? `0 ${scaleSize(10)}px` : `${scaleSize(10)}px`)};
`;

const ListItemPurchaseInfo = styled(ListItemMetadata)`
  text-transform: uppercase;
  font-size: ${scaleSize(24)}px;
  margin-top: ${({ showProgress }) => (showProgress ? `${scaleSize(35)}px` : `${scaleSize(-11)}px`)};
`;

const ListItemCover = styled.div.attrs(({ itemSize, cover, itemType }) => ({
  style: {
    width: `${scaleSize(itemSize.width)}px`,
    height: `${scaleSize(itemSize.height)}px`,
    backgroundImage: `url(${getImagePath(cover, scaleSize(itemSize.width), scaleSize(itemSize.height))})`,
    backgroundSize: parseInt(LIST_ITEMS_BACKGROUND_BY_TYPE[itemType].backgroundSize, 10)
      ? `${scaleSize(LIST_ITEMS_BACKGROUND_BY_TYPE[itemType].backgroundSize)}px ${scaleSize(
          LIST_ITEMS_BACKGROUND_BY_TYPE[itemType].backgroundSize,
        )}px`
      : `${LIST_ITEMS_BACKGROUND_BY_TYPE[itemType].backgroundSize}`,

    backgroundPosition: parseInt(LIST_ITEMS_BACKGROUND_BY_TYPE[itemType].backgroundPosition, 10)
      ? `${scaleSize(LIST_ITEMS_BACKGROUND_BY_TYPE[itemType].backgroundPosition)}px ${scaleSize(
          LIST_ITEMS_BACKGROUND_BY_TYPE[itemType].backgroundPosition,
        )}px`
      : `${LIST_ITEMS_BACKGROUND_BY_TYPE[itemType].backgroundPosition}`,
  },
}))`
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  border-radius: ${scaleSize(12)}px;
  transform: translate3d(0, 0, 0);
  transition: ${config.withAnimation ? 'transform 0.2s' : 'none'};
  background-repeat: no-repeat;
  position: relative;
`;

const ListItemCoverCatchUpInfo = styled.div`
  width: ${({ itemSize }) => scaleSize(itemSize.width) - scaleSize(40)}px;
  display: block;
  position: absolute;
  left: ${scaleSize(40)}px;
  bottom: ${scaleSize(0)}px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
  padding: ${({ itemType }) => (itemType === 'catchup-search' ? `${scaleSize(12)}px 0` : `${scaleSize(18)}px 0`)};
  border-bottom-right-radius: ${scaleSize(12)}px;
  background: linear-gradient(275.84deg, rgba(1, 1, 1, 0.75) 38.08%, rgba(0, 0, 0, 0) 92.09%);

  & > i {
    white-space: nowrap;
    display: block;
    font-style: normal;
    color: ${({ theme, isSoon, isLive, isAnnounce }) => {
      if (isSoon) return '#e6bc00';
      if (isLive) return theme.onAirLabelColor;
      if (isAnnounce) return theme.defaultColor;
      return theme.catchUpLabelColor;
    }};
    font-size: ${({ itemType }) => (itemType === 'catchup-search' ? scaleSize(26) : scaleSize(28))}px;
    margin-bottom: ${scaleSize(2)}px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: ${({ itemType }) => (itemType === 'catchup-medium' ? scaleSize(128) : scaleSize(20))}px;
  }

  &:before {
    content: '';
    display: ${({ isLive }) => (isLive ? 'block' : 'none')};
    position: absolute;
    top: ${scaleSize(27)}px;
    right: ${({ itemType }) => scaleSize(itemType === 'catchup-medium' ? 226 : 120)}px;
    width: ${scaleSize(16)}px;
    height: ${scaleSize(16)}px;
    border-radius: ${scaleSize(16)}px;
    background-color: ${({ theme }) => theme.onAirLabelColor};
  }

  & > span {
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.defaultColor};
    font-size: ${({ itemType }) => (itemType === 'catchup-search' ? scaleSize(26) : scaleSize(28))}px;
    padding-right: ${({ itemType }) => (itemType === 'catchup-medium' ? scaleSize(128) : scaleSize(20))}px;
  }
`;

const ListItemCoverCatchUpLogo = styled.div.attrs(({ logo }) => ({
  style: {
    backgroundImage: `url(${getImagePath(logo, scaleSize(62), scaleSize(62))})`,
  },
}))`
  position: absolute;
  bottom: ${scaleSize(18)}px;
  right: ${scaleSize(36)}px;
  width: ${scaleSize(62)}px;
  height: ${scaleSize(62)}px;
  background-size: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
`;

const ViewAll = styled.div`
  width: 100%;
  white-space: normal;
  text-align: center;
  color: #ffffff;
  font-size: ${scaleSize(38)}px;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.33;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

const RemoveItem = styled.div`
  width: ${scaleSize(96)}px;
  height: ${scaleSize(96)}px;
  box-sizing: border-box;
  padding-top: ${scaleSize(32)}px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -${scaleSize(48)}px 0 0 -${scaleSize(48)}px;
  border-radius: 50%;
  background: rgba(244, 244, 244, 0.5);
  box-shadow: 0 0 15px 2px rgba(0, 0, 0, 0.25);
`;

const ListItemWrapper = styled(Focusable)`
  width: ${({ itemSize }) => scaleSize(itemSize.width)}px;
  height: ${({ itemSize }) => scaleSize(itemSize.height + itemSize.metadataHeight)}px;
  display: inline-block;
  text-align: center;
  margin-right: ${scaleSize(LIST_ITEM_MARGIN)}px;
  box-sizing: border-box;
  cursor: pointer;
  vertical-align: top;
  position: relative;

  &:hover {
    & > ${ListItemCover} {
      transform: translate3d(0, -${scaleSize(10)}px, 0);
    }

    & > ${ListItemTitle} {
      margin-top: ${({ contentSize }) => (contentSize === LIST_TYPES.SMALL_BANNER ? `${scaleSize(-110)}px` : 0)};
    }

    & > ${ListItemFiltersTitle} {
      transform: translate3d(0, -${scaleSize(10)}px, 0);
    }
  }

  &:focus {
    & > ${ListItemCover} {
      ${RemoveItem} {
        background: ${({ theme }) => theme.activeColor};
        transform: scale(1.3);
      }
      transform: translate3d(0, -${({ transformOnFocus }) => (transformOnFocus ? scaleSize(20) : 0)}px, 0);

      background-color: ${({ contentSize, theme }) =>
        contentSize === LIST_TYPES.SMALL_BANNER ? 'none' : theme.imagePlaceholder};

      &:after {
        content: '';
        display: block;
        width: ${({ itemSize }) => scaleSize(itemSize.width - 15)}px;
        height: ${({ itemSize }) => scaleSize(itemSize.height - 15)}px;
        position: absolute;
        border: solid ${scaleSize(8)}px ${({ theme }) => theme.activeColor};
        border-radius: ${scaleSize(12)}px;
      }
    }

    & > ${ListItemTitle} {
      color: ${({ contentSize, theme }) =>
        contentSize === LIST_TYPES.SMALL_BANNER ? theme.defaultColor : theme.activeColor};
      margin-top: ${({ contentSize }) =>
        contentSize === LIST_TYPES.SMALL_BANNER ? `${scaleSize(-120)}px` : `${scaleSize(10)}px`};
    }

    & > ${ListItemMetadata} {
      color: ${({ theme }) => theme.activeColor};
    }

    & > ${ListItemFiltersTitle} {
      transform: translate3d(0, -${scaleSize(10)}px, 0);
    }
  }
`;

class ListItem extends PureComponent {
  onFocus = () => {
    const { onFocus, item, itemIndex } = this.props;

    onFocus && onFocus(item, itemIndex);
  };

  onEnter = (payload) => {
    const { onEnter, item } = this.props;

    onEnter(item, payload);
  };
  // TODO: Убрать, title должен приходить как обычная строка
  getItemTitle() {
    const { item, contentSize } = this.props;

    if (!item.title && !item.titles) {
      return '';
    }

    if (contentSize === LIST_TYPES.BANNER) {
      return '';
    }

    if (item.metadata && item.metadata.contentType === 'EPISODE')
      return `${i18n.t('detailsVOD.episode')} ${item.metadata.episodeNumber}`;

    if (item.titles) {
      const fallback = get(item, ['titles', 'UA', 'title'], get(item, ['titles', 'UA'], item.title));
      /*
       * Sometimes fallback could be an object, so need to replace
       * it with string/undefined to prevent app crash
       * */
      const extraFallback = get(item.title, ['title']);
      let localizedTitle = getLocalized(item.titles, isString(fallback) ? fallback : extraFallback);

      localizedTitle = this.trimListTitle(localizedTitle);

      return localizedTitle.length > 1 ? localizedTitle : '';
    }

    if (typeof item.title === 'string') {
      return this.trimListTitle(item.title);
    }

    if (item.title.title) {
      return this.trimListTitle(item.title.title);
    }
  }

  trimListTitle(localizedTitle) {
    const { showProgress, contentSize } = this.props;
    const MAX_TITLE_LENGTH = showProgress ? 19 : contentSize === 'MEDIUM' ? 45 : 30;

    if (localizedTitle.length <= MAX_TITLE_LENGTH) {
      return localizedTitle;
    }

    return `${localizedTitle.slice(0, MAX_TITLE_LENGTH - 1)}...`;
  }

  getPurchaseLabel() {
    const { item } = this.props;
    const itemTypes = item.vodTypes || item.types;
    const isChannel = item.tvServices || false;

    if (!['NOT_AUTHENTICATED', 'MISSING_SUBSCRIPTION'].includes(item.visibilityDetails) || (!itemTypes && !isChannel))
      return '';

    // предполагается, что каналы всегда по SVOD
    if (isChannel) {
      return i18n.t('detailsVOD.svod');
    }

    if (itemTypes.indexOf('SVOD') !== -1) {
      return i18n.t('detailsVOD.svod');
    }

    return i18n.t('detailsVOD.order');
  }

  getItemType() {
    const { item, contentSize, id } = this.props;
    const isSmallSearchPreview = `${id}`.includes('search');

    if (item.type === 'FILTERS_BANNER') {
      return 'filters_banner';
    }

    if (item.type === 'BANNER') {
      if (contentSize === LIST_TYPES.SMALL_BANNER) {
        return 'small_banner';
      }
      return 'banner';
    }

    if (item.tvServices || item.state === 'LIVE' || item.type === 'CHANNEL') {
      return 'channel';
    }

    if (item.epgEvent || item.contentType === 'EPG_EVENT') {
      if (contentSize === 'LARGE') return 'catchup-large';
      if (contentSize === 'MEDIUM') return 'catchup-medium';
      if (isSmallSearchPreview) return 'catchup-search';
      return 'catchup';
    }

    return 'vod';
  }
  // TODO: Убрать. Это должно приходить как props
  formatWatchedTime = (duration) => {
    if (!duration) return '';

    const sec = parseInt(duration, 10);
    const hours = Math.floor(sec / 3600);
    const minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
    const seconds = sec - hours * 3600 - minutes * 60; //  get seconds

    let humanizeDuration = '';
    if (hours > 0) humanizeDuration += i18n.t('detailsVOD.duration.hours', { count: hours });
    if (minutes > 0) humanizeDuration += i18n.t('detailsVOD.duration.minutes', { count: minutes });
    if (minutes <= 0 && hours <= 0) humanizeDuration += i18n.t('detailsVOD.duration.seconds', { count: seconds });

    return humanizeDuration;
  };

  getCatchupInfo = (imgUrl) => {
    const { itemSize, item } = this.props;
    const itemType = this.getItemType();
    const now = moment().add(config.timeDiffFromServer, 'm');
    const startTimeKievTime = moment(item.epgEvent?.startTime ?? item.eventStartTime);
    const startTimeDiff = startTimeKievTime.diff(now, 'm');
    const epgEventState = item.epgEvent?.state ?? item.epgEventState;
    const isLive = epgEventState === 'LIVE' || epgEventState === 'LIVE_CATCHUP';
    // Sometimes we get live status for programs while they technically haven't started yet.
    // In this overlaping case we need to prevent live to render as "Soon".
    const isSoon = !isLive && startTimeDiff >= 0 && startTimeDiff < 30;
    const isAnnounce = startTimeDiff > 30;

    const renderSize = itemType === 'catchup-medium' ? LIST_ITEMS_SIZE.MEDIUM : itemSize;

    let status = i18n.t('epg.catchup');
    if (isLive) status = i18n.t('epg.onAir');
    if (isSoon) status = i18n.t('epg.soon');
    if (isAnnounce) status = i18n.t('epg.announce');

    return (
      <ListItemCoverCatchUpInfo
        itemSize={renderSize}
        itemType={itemType}
        isSoon={isSoon}
        isLive={isLive}
        isAnnounce={isAnnounce}
      >
        {itemType === 'catchup-medium' && <ListItemCoverCatchUpLogo logo={imgUrl} />}
        <i>{status}</i>
        <span>{startTimeKievTime.locale(INIT_UI_LANGUAGE).format('HH:mm, DD MMM')}</span>
      </ListItemCoverCatchUpInfo>
    );
  };

  render() {
    const { id, item, itemSize, hideTitle, editMode, showProgress, className, payload, isActive, contentSize } =
      this.props;

    const itemType = this.getItemType();
    const renderSize = itemType === 'catchup-medium' ? LIST_ITEMS_SIZE.MEDIUM : itemSize;
    const bookmarkTime = get(item, 'bookmarkSeconds') || get(item, 'bookmark.seconds') || 0;
    const itemPurchaseLabel = ['NOT_AUTHENTICATED', 'MISSING_SUBSCRIPTION'].includes(item.visibilityDetails) && (
      <ListItemPurchaseInfo hideTitle={hideTitle} showProgress={showProgress}>
        {this.getPurchaseLabel()}
      </ListItemPurchaseInfo>
    );

    let coverImgUrl = item.imageUrl;
    if (contentSize === 'MEDIUM') coverImgUrl = item.imageUrls?.['tablet16:9Horizontal'] ?? item.imageUrl;

    const isCatchUp =
      ['catchup', 'catchup-medium', 'catchup-search'].includes(itemType) ||
      (itemType === 'channel' && !!item.epgEventState);
    const catchupInfoComponent = isCatchUp && this.getCatchupInfo(coverImgUrl);

    let coverImageByType = coverImgUrl;

    if (itemType === 'catchup-medium') {
      coverImageByType = get(item, 'imageUrls.catchUpBackground', null);
    }

    return (
      <ListItemWrapper
        className={className}
        onFocus={this.onFocus}
        onEnter={this.onEnter}
        id={id}
        itemSize={renderSize}
        transformOnFocus={itemType !== 'banner'}
        payload={payload}
        contentSize={contentSize}
      >
        <ListItemCover itemSize={renderSize} cover={coverImageByType} itemType={itemType} contentSize={contentSize}>
          {item.type === 'VIEW_ALL' && <ViewAll>{item.title}</ViewAll>}
          {editMode && (
            <RemoveItem>
              <CrossIcon />
            </RemoveItem>
          )}
          {item.type === 'EPISODE' && <StyledPlayIcon isActive={isActive} />}
          {catchupInfoComponent}
        </ListItemCover>
        {item.type === 'FILTERS_BANNER' && (
          <ListItemFiltersTitle itemSize={renderSize} contentSize={contentSize}>
            <span>{this.getItemTitle()}</span>
          </ListItemFiltersTitle>
        )}
        {item.type !== 'VIEW_ALL' && item.type !== 'FILTERS_BANNER' && !showProgress && (
          <>
            <ListItemTitle itemSize={renderSize} hideTitle={hideTitle} contentSize={contentSize}>
              {this.getItemTitle()}
            </ListItemTitle>
            {itemPurchaseLabel}
          </>
        )}
        {item.type !== 'VIEW_ALL' && showProgress && (
          <>
            <ListItemTitle itemSize={renderSize} showProgress={showProgress}>
              {this.getItemTitle()}
            </ListItemTitle>
            {itemPurchaseLabel}
          </>
        )}
        {showProgress && +!hideTitle && bookmarkTime ? (
          <Progress
            progress={bookmarkTime / (item.runTimeInSeconds || runtimeToSeconds(item.title.runTime))}
            itemType={itemType}
          />
        ) : null}
      </ListItemWrapper>
    );
  }
}

// Hack! Bridge for old non-clean code
export const ListItemCleanWrapper = memo(({ id, index, item, onFocus, onEnter, itemSize, contentSize }) => {
  return (
    <ListItem
      key={id}
      id={`${id}`}
      onFocus={() => onFocus(index)}
      onEnter={() => onEnter(index)}
      itemIndex={index}
      item={item}
      contentSize={contentSize}
      itemSize={LIST_ITEMS_SIZE[contentSize] || itemSize || LIST_ITEMS_SIZE.LARGE}
    />
  );
});

export default ListItem;
